import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type AnalyticsProps = IconComponentBaseProps;

export const Analytics = ({
  className,
  width = 20,
  height = 20,
  fill = defaultTheme.mantineColors.gray[7],
}: AnalyticsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_4163_306581"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4163_306581)">
        <path
          d="M6.76292 9.99999C6.58556 9.99999 6.43702 10.0599 6.31729 10.1796C6.19771 10.2992 6.13792 10.4476 6.13792 10.625V13.3333C6.13792 13.5107 6.19771 13.6592 6.31729 13.7787C6.43702 13.8985 6.58556 13.9583 6.76292 13.9583C6.94014 13.9583 7.08861 13.8985 7.20834 13.7787C7.32792 13.6592 7.38771 13.5107 7.38771 13.3333V10.625C7.38771 10.4476 7.32792 10.2992 7.20834 10.1796C7.08861 10.0599 6.94014 9.99999 6.76292 9.99999ZM13.2371 5.83332C13.0599 5.83332 12.9114 5.89318 12.7917 6.01291C12.6721 6.13249 12.6123 6.28096 12.6123 6.45832V13.3333C12.6123 13.5107 12.6721 13.6592 12.7917 13.7787C12.9114 13.8985 13.0599 13.9583 13.2371 13.9583C13.4144 13.9583 13.563 13.8985 13.6827 13.7787C13.8023 13.6592 13.8621 13.5107 13.8621 13.3333V6.45832C13.8621 6.28096 13.8023 6.13249 13.6827 6.01291C13.563 5.89318 13.4144 5.83332 13.2371 5.83332ZM10 11.6667C9.82264 11.6667 9.67417 11.7265 9.55459 11.8462C9.43486 11.9658 9.375 12.1143 9.375 12.2917V13.3333C9.375 13.5107 9.43486 13.6592 9.55459 13.7787C9.67417 13.8985 9.82264 13.9583 10 13.9583C10.1774 13.9583 10.3258 13.8985 10.4454 13.7787C10.5651 13.6592 10.625 13.5107 10.625 13.3333V12.2917C10.625 12.1143 10.5651 11.9658 10.4454 11.8462C10.3258 11.7265 10.1774 11.6667 10 11.6667ZM4.42313 17.0833C4.00215 17.0833 3.64583 16.9375 3.35417 16.6458C3.0625 16.3542 2.91667 15.9978 2.91667 15.5769V4.42312C2.91667 4.00214 3.0625 3.64582 3.35417 3.35416C3.64583 3.06249 4.00215 2.91666 4.42313 2.91666H15.5769C15.9979 2.91666 16.3542 3.06249 16.6458 3.35416C16.9375 3.64582 17.0833 4.00214 17.0833 4.42312V15.5769C17.0833 15.9978 16.9375 16.3542 16.6458 16.6458C16.3542 16.9375 15.9979 17.0833 15.5769 17.0833H4.42313ZM4.42313 15.8333H15.5769C15.641 15.8333 15.6998 15.8066 15.7531 15.7531C15.8066 15.6998 15.8333 15.641 15.8333 15.5769V4.42312C15.8333 4.35895 15.8066 4.3002 15.7531 4.24686C15.6998 4.19339 15.641 4.16666 15.5769 4.16666H4.42313C4.35896 4.16666 4.30021 4.19339 4.24688 4.24686C4.1934 4.3002 4.16667 4.35895 4.16667 4.42312V15.5769C4.16667 15.641 4.1934 15.6998 4.24688 15.7531C4.30021 15.8066 4.35896 15.8333 4.42313 15.8333ZM10 9.79166C10.1774 9.79166 10.3258 9.7318 10.4454 9.61207C10.5651 9.49249 10.625 9.34402 10.625 9.16666C10.625 8.9893 10.5651 8.84082 10.4454 8.72124C10.3258 8.60152 10.1774 8.54166 10 8.54166C9.82264 8.54166 9.67417 8.60152 9.55459 8.72124C9.43486 8.84082 9.375 8.9893 9.375 9.16666C9.375 9.34402 9.43486 9.49249 9.55459 9.61207C9.67417 9.7318 9.82264 9.79166 10 9.79166Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
